// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import './NotFound.scss';

@observer class NotFound extends Component<any, any> {
	render() {
		return (
			<div className="page-not-found">
				<h2>404 - Page not found</h2>
			</div>
		)
	}
}

export default NotFound;

